import { render } from "./PDI.vue?vue&type=template&id=04c5a0ef"
import script from "./PDI.vue?vue&type=script&lang=js"
export * from "./PDI.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-client/megaluzz-client/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__